(() => {
  if (window.spoilsCartLoungeUpsellLoaded) return;
  window.spoilsCartLoungeUpsellLoaded = true;

  const moduleFor = (target) => target.closest('[data-cart-lounge-cover]');
  const duoQaDiscountCodeFor = (drawer) => drawer?.dataset.cartDuoQaDiscountCode || '';
  let duoQaRepairAttempted = false;
  let duoQaRepairInFlight = false;

  const repairDuoQaDiscount = async () => {
    if (duoQaRepairAttempted || duoQaRepairInFlight) return;

    const drawer = document.querySelector('cart-drawer[data-cart-duo-qa-needs-discount="true"]');
    const duoQaDiscountCode = duoQaDiscountCodeFor(drawer);
    if (!drawer || !duoQaDiscountCode) return;

    duoQaRepairAttempted = true;
    duoQaRepairInFlight = true;

    try {
      const routesRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${routesRoot}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ discount: duoQaDiscountCode })
      });
      const cart = await response.json();
      const hasDuoDiscountAllocation = Array.isArray(cart.items)
        && cart.items.some((item) => (
          (item.line_level_discount_allocations || item.discount_allocations || []).some((allocation) => (
            allocation.discount_application?.title === duoQaDiscountCode
            && Number(allocation.amount || 0) > 0
          ))
        ));
      const hasDuoDiscount = response.ok && hasDuoDiscountAllocation;

      if (!hasDuoDiscount) {
        throw new Error('The $333 two-Lounge price could not be applied.');
      }

      if (window.location.pathname.replace(/\/+$/, '').endsWith('/cart')) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (_) {
      drawer.removeAttribute('data-cart-duo-qa-needs-discount');
    } finally {
      duoQaRepairInFlight = false;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('cart-drawer form.cart-drawer__footer');
    const drawer = form?.closest('cart-drawer[data-cart-duo-qa-eligible="true"]');
    const duoQaDiscountCode = duoQaDiscountCodeFor(drawer);
    if (!form || !drawer || !duoQaDiscountCode) return;

    let discountInput = form.querySelector('input[name="discount"]');
    if (!discountInput) {
      discountInput = document.createElement('input');
      discountInput.type = 'hidden';
      discountInput.name = 'discount';
      form.appendChild(discountInput);
    }
    discountInput.value = duoQaDiscountCode;
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairDuoQaDiscount, { once: true });
  } else {
    repairDuoQaDiscount();
  }

  document.addEventListener('click', async (event) => {
    const swatch = event.target.closest('[data-cart-cover-swatch]');
    if (swatch) {
      const module = moduleFor(swatch);
      if (!module) return;

      module.dataset.selectedCoverVariantId = swatch.dataset.coverVariantId || '';
      module.querySelectorAll('[data-cart-cover-swatch]').forEach((candidate) => {
        const active = candidate === swatch;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const selection = module.querySelector('[data-cart-cover-selection]');
      const compare = module.querySelector('.cart-lounge-cover__price s');
      if (selection) selection.textContent = `${swatch.dataset.coverColor || 'Selected'} cover only`;
      if (compare && swatch.dataset.coverRegularPrice) compare.textContent = swatch.dataset.coverRegularPrice;
      return;
    }

    const addButton = event.target.closest('[data-cart-cover-add]');
    if (!addButton) return;

    const module = moduleFor(addButton);
    const variantId = Number(module?.dataset.selectedCoverVariantId || 0);
    if (!module || !variantId || addButton.getAttribute('aria-busy') === 'true') return;

    const message = module.querySelector('[data-cart-cover-message]');
    const activeSwatch = module.querySelector('[data-cart-cover-swatch][aria-pressed="true"]');
    const routesRoot = window.Shopify?.routes?.root || '/';
    const sections = [];

    addButton.setAttribute('aria-busy', 'true');
    addButton.disabled = true;
    addButton.textContent = 'ADDING';
    if (message) message.hidden = true;
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections }
    }));

    try {
      const response = await fetch(`${routesRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              '_Added with': 'The Lounge',
              'Cover color': activeSwatch?.dataset.coverColor || ''
            }
          }],
          sections: sections.join(','),
          sections_url: `${routesRoot}cart`
        })
      });
      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || 'This cover could not be added.');
      }

      if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
        window.location.href = `${routesRoot}cart`;
        return;
      }

      const cart = await (await fetch(`${routesRoot}cart.js`)).json();
      cart.sections = responseJson.sections || {};
      module.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.items || [responseJson],
          cart,
          onSuccessDo: 'force_open_drawer'
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart,
          onSuccessDo: 'force_open_drawer'
        }
      }));
    } catch (error) {
      if (message) {
        message.textContent = error.message || 'This cover could not be added.';
        message.hidden = false;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      addButton.removeAttribute('aria-busy');
      addButton.disabled = false;
      addButton.textContent = 'ADD COVER';
    }
  });
})();
